import ComapnyBgImage from "./../assets/images/backgroundImage.png"

export const countryList = [
    {
        "id": 1,
        "name": "Afghanistan"
    },
    {
        "id": 2,
        "name": "Albania"
    },
    {
        "id": 3,
        "name": "Algeria"
    },
    {
        "id": 4,
        "name": "Andorra"
    },
    {
        "id": 5,
        "name": "Angola"
    },
    {
        "id": 6,
        "name": "Antigua and Barbuda"
    },
    {
        "id": 7,
        "name": "Argentina"
    },
    {
        "id": 8,
        "name": "Armenia"
    },
    {
        "id": 9,
        "name": "Australia"
    },
    {
        "id": 10,
        "name": "Austria"
    },
    {
        "id": 11,
        "name": "Azerbaijan"
    },
    {
        "id": 12,
        "name": "The Bahamas"
    },
    {
        "id": 13,
        "name": "Bahrain"
    },
    {
        "id": 14,
        "name": "Bangladesh"
    },
    {
        "id": 15,
        "name": "Barbados"
    },
    {
        "id": 16,
        "name": "Belarus"
    },
    {
        "id": 17,
        "name": "Belgium"
    },
    {
        "id": 18,
        "name": "Belize"
    },
    {
        "id": 19,
        "name": "Benin"
    },
    {
        "id": 20,
        "name": "Bhutan"
    },
    {
        "id": 21,
        "name": "Bolivia"
    },
    {
        "id": 22,
        "name": "Bosnia and Herzegovina"
    },
    {
        "id": 23,
        "name": "Botswana"
    },
    {
        "id": 24,
        "name": "Brazil"
    },
    {
        "id": 25,
        "name": "Brunei"
    },
    {
        "id": 26,
        "name": "Bulgaria"
    },
    {
        "id": 27,
        "name": "Burkina Faso"
    },
    {
        "id": 28,
        "name": "Burundi"
    },
    {
        "id": 29,
        "name": "Cabo Verde"
    },
    {
        "id": 30,
        "name": "Cambodia"
    },
    {
        "id": 31,
        "name": "Cameroon"
    },
    {
        "id": 32,
        "name": "Canada"
    },
    {
        "id": 33,
        "name": "Central African Republic"
    },
    {
        "id": 34,
        "name": "Chad"
    },
    {
        "id": 35,
        "name": "Chile"
    },
    {
        "id": 36,
        "name": "China"
    },
    {
        "id": 37,
        "name": "Colombia"
    },
    {
        "id": 38,
        "name": "Comoros"
    },
    {
        "id": 39,
        "name": "Congo"
    },
    {
        "id": 40,
        "name": "Congo (DRC)"
    },
    {
        "id": 41,
        "name": "Costa Rica"
    },
    {
        "id": 42,
        "name": "Côte d’Ivoire"
    },
    {
        "id": 43,
        "name": "Croatia"
    },
    {
        "id": 44,
        "name": "Cuba"
    },
    {
        "id": 45,
        "name": "Cyprus"
    },
    {
        "id": 46,
        "name": "Czech Republic"
    },
    {
        "id": 47,
        "name": "Denmark"
    },
    {
        "id": 48,
        "name": "Djibouti"
    },
    {
        "id": 49,
        "name": "Dominica"
    },
    {
        "id": 50,
        "name": "Dominican Republic"
    },
    {
        "id": 51,
        "name": "Ecuador"
    },
    {
        "id": 52,
        "name": "Egypt"
    },
    {
        "id": 53,
        "name": "El Salvador"
    },
    {
        "id": 54,
        "name": "Equatorial Guinea"
    },
    {
        "id": 55,
        "name": "Eritrea"
    },
    {
        "id": 56,
        "name": "Estonia"
    },
    {
        "id": 57,
        "name": "Ethiopia"
    },
    {
        "id": 58,
        "name": "Fiji"
    },
    {
        "id": 59,
        "name": "Finland"
    },
    {
        "id": 60,
        "name": "France"
    },
    {
        "id": 61,
        "name": "Gabon"
    },
    {
        "id": 62,
        "name": "Georgia"
    },
    {
        "id": 63,
        "name": "Germany"
    },
    {
        "id": 64,
        "name": "Ghana"
    },
    {
        "id": 65,
        "name": "Greece"
    },
    {
        "id": 66,
        "name": "Grenada"
    },
    {
        "id": 67,
        "name": "Guatemala"
    },
    {
        "id": 68,
        "name": "Guinea"
    },
    {
        "id": 69,
        "name": "Guinea-Bissau"
    },
    {
        "id": 70,
        "name": "Guyana"
    },
    {
        "id": 71,
        "name": "Haiti"
    },
    {
        "id": 72,
        "name": "Honduras"
    },
    {
        "id": 73,
        "name": "Hungary"
    },
    {
        "id": 74,
        "name": "Iceland"
    },
    {
        "id": 75,
        "name": "India"
    },
    {
        "id": 76,
        "name": "Indonesia"
    },
    {
        "id": 77,
        "name": "Iran"
    },
    {
        "id": 78,
        "name": "Iraq"
    },
    {
        "id": 79,
        "name": "Ireland"
    },
    {
        "id": 80,
        "name": "Israel"
    },
    {
        "id": 81,
        "name": "Italy"
    },
    {
        "id": 82,
        "name": "Jamaica"
    },
    {
        "id": 83,
        "name": "Japan"
    },
    {
        "id": 84,
        "name": "Jordan"
    },
    {
        "id": 85,
        "name": "Kazakhstan"
    },
    {
        "id": 86,
        "name": "Kenya"
    },
    {
        "id": 87,
        "name": "Kiribati"
    },
    {
        "id": 88,
        "name": "Korea, North"
    },
    {
        "id": 89,
        "name": "Kosovo"
    },
    {
        "id": 90,
        "name": "Kuwait"
    },
    {
        "id": 91,
        "name": "Kyrgyzstan"
    },
    {
        "id": 92,
        "name": "Laos"
    },
    {
        "id": 93,
        "name": "Latvia"
    },
    {
        "id": 94,
        "name": "Lebanon"
    },
    {
        "id": 95,
        "name": "Lesotho"
    },
    {
        "id": 96,
        "name": "Liberia"
    },
    {
        "id": 97,
        "name": "Libya"
    },
    {
        "id": 98,
        "name": "Liechtenstein"
    },
    {
        "id": 99,
        "name": "Lithuania"
    },
    {
        "id": 100,
        "name": "Luxembourg"
    },
    {
        "id": 101,
        "name": "Madagascar"
    },
    {
        "id": 102,
        "name": "Malawi"
    },
    {
        "id": 103,
        "name": "Malaysia"
    },
    {
        "id": 104,
        "name": "Maldives"
    },
    {
        "id": 105,
        "name": "Mali"
    },
    {
        "id": 106,
        "name": "Malta"
    },
    {
        "id": 107,
        "name": "Marshall Islands"
    },
    {
        "id": 108,
        "name": "Mauritania"
    },
    {
        "id": 109,
        "name": "Mauritius"
    },
    {
        "id": 110,
        "name": "Mexico"
    },
    {
        "id": 111,
        "name": "Micronesia"
    },
    {
        "id": 112,
        "name": "Moldova"
    },
    {
        "id": 113,
        "name": "Monaco"
    },
    {
        "id": 114,
        "name": "Mongolia"
    },
    {
        "id": 115,
        "name": "Montenegro"
    },
    {
        "id": 116,
        "name": "Morocco"
    },
    {
        "id": 117,
        "name": "Mozambique"
    },
    {
        "id": 118,
        "name": "Myanmar"
    },
    {
        "id": 119,
        "name": "Namibia"
    },
    {
        "id": 120,
        "name": "Nauru"
    },
    {
        "id": 121,
        "name": "Nepal"
    },
    {
        "id": 122,
        "name": "Netherlands"
    },
    {
        "id": 123,
        "name": "New Zealand"
    },
    {
        "id": 124,
        "name": "Nicaragua"
    },
    {
        "id": 125,
        "name": "Niger"
    },
    {
        "id": 126,
        "name": "Nigeria"
    },
    {
        "id": 127,
        "name": "Norway"
    },
    {
        "id": 128,
        "name": "Oman"
    },
    {
        "id": 129,
        "name": "Pakistan"
    },
    {
        "id": 130,
        "name": "Palau"
    },
    {
        "id": 131,
        "name": "Panama"
    },
    {
        "id": 132,
        "name": "Papua New Guinea"
    },
    {
        "id": 133,
        "name": "Paraguay"
    },
    {
        "id": 134,
        "name": "Peru"
    },
    {
        "id": 135,
        "name": "Philippines"
    },
    {
        "id": 136,
        "name": "Poland"
    },
    {
        "id": 137,
        "name": "Portugal"
    },
    {
        "id": 138,
        "name": "Qatar"
    },
    {
        "id": 139,
        "name": "Romania"
    },
    {
        "id": 140,
        "name": "Russia"
    },
    {
        "id": 141,
        "name": "Rwanda"
    },
    {
        "id": 142,
        "name": "Saint Kitts and Nevis"
    },
    {
        "id": 143,
        "name": "Saint Lucia"
    },
    {
        "id": 144,
        "name": "Saint Vincent and the Grenadines"
    },
    {
        "id": 145,
        "name": "Samoa"
    },
    {
        "id": 146,
        "name": "San Marino"
    },
    {
        "id": 147,
        "name": "Sao Tome and Principe"
    },
    {
        "id": 148,
        "name": "Saudi Arabia"
    },
    {
        "id": 149,
        "name": "Senegal"
    },
    {
        "id": 150,
        "name": "Serbia"
    },
    {
        "id": 151,
        "name": "Seychelles"
    },
    {
        "id": 152,
        "name": "Sierra Leone"
    },
    {
        "id": 153,
        "name": "Singapore"
    },
    {
        "id": 154,
        "name": "Slovakia"
    },
    {
        "id": 155,
        "name": "Slovenia"
    },
    {
        "id": 156,
        "name": "Solomon Islands"
    },
    {
        "id": 157,
        "name": "Somalia"
    },
    {
        "id": 158,
        "name": "South Africa"
    },
    {
        "id": 159,
        "name": "Spain"
    },
    {
        "id": 160,
        "name": "Sri Lanka"
    },
    {
        "id": 161,
        "name": "Sudan"
    },
    {
        "id": 162,
        "name": "Suriname"
    },
    {
        "id": 163,
        "name": "Sweden"
    },
    {
        "id": 164,
        "name": "Switzerland"
    },
    {
        "id": 165,
        "name": "Syria"
    },
    {
        "id": 166,
        "name": "Taiwan"
    },
    {
        "id": 167,
        "name": "Tajikistan"
    },
    {
        "id": 168,
        "name": "Tanzania"
    },
    {
        "id": 169,
        "name": "Thailand"
    },
    {
        "id": 170,
        "name": "Togo"
    },
    {
        "id": 171,
        "name": "Tonga"
    },
    {
        "id": 172,
        "name": "Trinidad and Tobago"
    },
    {
        "id": 173,
        "name": "Tunisia"
    },
    {
        "id": 174,
        "name": "Turkey"
    },
    {
        "id": 175,
        "name": "Turkmenistan"
    },
    {
        "id": 176,
        "name": "Tuvalu"
    },
    {
        "id": 177,
        "name": "Uganda"
    },
    {
        "id": 178,
        "name": "Ukraine"
    },
    {
        "id": 179,
        "name": "United Arab Emirates"
    },
    {
        "id": 180,
        "name": "United Kingdom"
    },
    {
        "id": 181,
        "name": "United States"
    },
    {
        "id": 182,
        "name": "Uruguay"
    },
    {
        "id": 183,
        "name": "Uzbekistan"
    },
    {
        "id": 184,
        "name": "Vanuatu"
    },
    {
        "id": 185,
        "name": "Vatican City"
    },
    {
        "id": 186,
        "name": "Venezuela"
    },
    {
        "id": 187,
        "name": "Vietnam"
    },
    {
        "id": 188,
        "name": "Yemen"
    },
    {
        "id": 189,
        "name": "Zambia"
    },
    {
        "id": 190,
        "name": "Zimbabwe"
    },
    {
        "id": 191,
        "name": "East Timor&nbsp;(Timor-Leste)"
    },
    {
        "id": 192,
        "name": "Eswatini"
    },
    {
        "id": 193,
        "name": "The Gambia"
    },
    {
        "id": 194,
        "name": "Korea, South"
    },
    {
        "id": 195,
        "name": "North Macedonia"
    },
    {
        "id": 196,
        "name": "Sudan, South"
    }
];

export const defaultTemplate = {
    bgImage: ComapnyBgImage,      //Default Backgroud Image path from s3
    color : "#102F4E",
    appImage: ""// Default Comapny logo path from s3
};

export const appConst = {
    EmptyGuid: "00000000-0000-0000-0000-000000000000"
};